import React from "react";
import "./AppLayout.css";
import HomeLayout from "./homeLayout/HomeLayout";

const AppLayout = () => {
  return (
    <div className="app-background">
      <HomeLayout />
    </div>
  );
};

export default AppLayout;
